"use strict";
exports.__esModule = true;
exports.isNumber = function (val) { return typeof val == 'number'; };
exports.isString = function (val) { return typeof val == 'string'; };
exports.isBoolean = function (val) { return !!val === val; };
exports.isArray = function (val) { return Array.isArray(val); };
exports.Type = {
    NUMBER: exports.isNumber,
    STRING: exports.isString,
    BOOLEAN: exports.isBoolean,
    ARRAY: exports.isArray
};
function optional(value, validator, errorMessage) {
    if (value == null || validator(value)) {
        return value;
    }
    throw new Error(errorMessage || "invalid type of value detected");
}
exports.optional = optional;
function required(value, validator, errorMessage) {
    if (value == null) {
        throw new Error(errorMessage || 'value required');
    }
    if (!validator(value)) {
        throw new Error(errorMessage || 'invalid type of value');
    }
    return value;
}
exports.required = required;
function optionalOfType(d, key, validator, errorMessage) {
    return optional(d[key], validator, errorMessage || "invalid type of value detected for " + key);
}
exports.optionalOfType = optionalOfType;
function requiredOfType(d, key, validator, errorMessage) {
    try {
        return required(d[key], validator, errorMessage);
    }
    catch (e) {
        throw errorMessage ? e : (markedUpError(e, key) || e);
    }
}
exports.requiredOfType = requiredOfType;
function markedUpError(error, key) {
    if (error.message === 'value required') {
        return new Error("value required for key: " + key);
    }
    else if (error.message === 'invalid type of value') {
        return new Error("invalid type of value detected for key: " + key);
    }
}
